var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "patternL",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.1,544.54c.46,1.43,1.33,2.87,1.31,4.29-.19,11.25-.66,22.49-.79,33.74-.05,4.42.73,8.84.82,13.27.15,7.13.04,14.26-1.14,21.77-.56-.96-1.59-1.91-1.62-2.88-.15-6.51-.09-13.03-.09-19.54v-50.33c.51-.11,1.01-.22,1.52-.33h0Z",
    className: "patternColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.85,569.01v52.96c-1-.88-2.12-1.42-2.12-1.95-.09-16.49-.07-32.99-.02-49.48,0-.54.65-1.07.99-1.6.38.02.77.05,1.15.07h0Z",
    className: "patternColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M502.29,621.55v-53.79c3.18,5.12,2.8,51.51,0,53.79Z",
    className: "patternColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M403.77,568.87v53.76c-1.07-2.22-2.1-3.38-2.11-4.54-.11-15.45-.09-30.9-.03-46.35,0-1,.64-1.99.98-2.99l1.15.12h0Z",
    className: "patternColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M410.13,640.41v-44.97c3.45,3.81,3.15,42.92,0,44.97Z",
    className: "patternColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M581.01,488.14v45c-3.26-2.57-3.4-41.84,0-45Z",
    className: "patternColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.91,641v-45.41c3.39,3,3.7,41.48,0,45.41Z",
    className: "patternColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M287.4,488.3c2.59,2.75,2.97,40.42.83,44.73-1.93-2.45-2.67-36.98-.83-44.73Z",
    className: "patternColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M217.91,486.79v-43.94c.45-.35.91-.7,1.36-1.04.36.87,1.04,1.75,1.04,2.62.03,13.63,0,27.25-.14,40.88,0,.41-1.19.8-2.27,1.49h.01Z",
    className: "patternColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M480.8,488.28v45.8c-3.16-4.57-2.83-38.97,0-45.8Z",
    className: "patternColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M211.84,526.91v41.31c-1.04-1.28-2.14-2.01-2.15-2.75-.09-12.32-.06-24.65,0-36.97,0-.55.58-1.09.89-1.64.42.02.84.04,1.25.05h0Z",
    className: "patternColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M311.69,567.61c-2.65-2.4-3.06-36.45,0-42.11v42.11Z",
    className: "patternColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M503.81,567.7c-2.55-2.29-3.28-34.52-1.31-40.48,2.23,1.79,3.23,30.49,1.31,40.48Z",
    className: "patternColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M509.85,636.75v-41.06c3.56,2.76,3.8,37.42,0,41.06Z",
    className: "patternColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M603.82,525.63v42.49c-.98-1.15-2.11-1.87-2.12-2.6-.07-12.49-.01-24.98.07-37.47,0-.37.59-.73,2.05-2.42h0Z",
    className: "patternColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M342.73,558.78v53.45h-1.35v-53.46h1.35Z",
    className: "patternColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M603.88,569.05v41.21c-3.86-13.64-1.66-27.48-2.26-41.24.75.01,1.51.02,2.26.03h0Z",
    className: "patternColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M549.87,542.25v39.07c-2.75-1.46-3.54-34.05,0-39.07Z",
    className: "patternColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M258.16,582.02c-3.74-3.37-3.35-36.98,0-39.41v39.41Z",
    className: "patternColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M349.75,663.25c-2.98-2.54-3.33-24.06,0-42.56v42.56Z",
    className: "patternColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M188.9,492.89v40.71c-3.17-3.55-3.15-31.17,0-40.71h0Z",
    className: "patternColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M342.73,661.73c-2.78-4.73-2.86-33.61,0-41.06v41.06Z",
    className: "patternColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M440.92,613.2v-55.35c.32,0,.65,0,.97-.01v55.35h-.97Z",
    className: "patternColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M457.01,617.7c-.47-.87-1.25-1.7-1.36-2.61-1.31-10.87-.09-32.79,2.33-34.76v36.94c-.32.14-.64.29-.97.43Z",
    className: "patternColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M450.11,664.01c-3.59-3.61-3.33-34.52,0-37.49v37.49Z",
    className: "patternColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M433.12,622.86c3.11,2.29,3.54,33.75,0,36.97v-36.97h0Z",
    className: "patternColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M163.86,617.25v-36.19c.28-.16.57-.32.85-.48.59,1.14,1.67,2.28,1.68,3.44.13,10.14.11,20.28.03,30.41,0,1.05-.69,2.1-1.05,3.15l-1.51-.34h0Z",
    className: "patternColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M355.82,617.08v-36.18c.36-.12.71-.25,1.07-.37.53,1.25,1.5,2.5,1.51,3.75.13,9.97.11,19.94.01,29.91-.01,1.14-.81,2.27-1.25,3.41-.45-.17-.89-.35-1.34-.52h0Z",
    className: "patternColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M548.27,509.63v-37.77c3.13,4.79,2.85,35.3,0,37.77Z",
    className: "patternColor"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M257.87,509.72c-3.03-3.09-3.21-33.44,0-37.52v37.52Z",
    className: "patternColor"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M534.82,469.18v37.74c-3.08-4.18-2.95-34.75,0-37.74Z",
    className: "patternColor"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M241.37,469.31c2.63,2.7,3,32.27.84,36.69-1.89-2.4-2.58-29.02-.84-36.69Z",
    className: "patternColor"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M448.36,581.75c-2.27-10.08-.99-34.06,1.77-35.55,1.39,12.87.59,33.13-1.77,35.55Z",
    className: "patternColor"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M266.21,580.87v34.79c-.23.13-.45.25-.68.38-.65-1.26-1.84-2.52-1.86-3.8-.15-9.81-.11-19.63-.02-29.44,0-.8.75-1.6,1.16-2.4.47.16.94.31,1.4.47h0Z",
    className: "patternColor"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M542.13,557.86v51.35c-.31,0-.62,0-.93.01v-51.36h.93Z",
    className: "patternColor"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M304.16,510.06c-3.66-3.84-3.37-29.96,0-33.49v33.49Z",
    className: "patternColor"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M496.18,475.59v34.42c-1.16-.98-2.19-1.42-2.38-2.09-1.32-4.71.01-28.66,2.38-32.33Z",
    className: "patternColor"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M204.13,509.43c-3.55-2.79-3.61-29.14,0-32.92v32.92h0Z",
    className: "patternColor"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M396.26,630.01v33.28c-3.57-2.24-3.91-28.03,0-33.28Z",
    className: "patternColor"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M595.95,509.43c-3.15-2.86-3.4-28.49,0-33.39v33.39h0Z",
    className: "patternColor"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M565.49,530.79v40.47c-.45,0-.9,0-1.34.01v-40.42c.45-.02.9-.04,1.34-.07h0Z",
    className: "patternColor"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M611.46,627.66c-3.12-10.53-1.41-21.13-1.29-31.71,2.58,2.57,3.27,22.18,1.29,31.71Z",
    className: "patternColor"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M212.15,468.15c-3.75-3.71-3.27-24.66,0-31.49v31.49Z",
    className: "patternColor"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M273.39,530.79v40.41c-.4,0-.8.01-1.19.02v-40.34l1.19-.1h0Z",
    className: "patternColor"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M542.13,503.86v40.35c-.32,0-.63,0-.95.01v-40.35h.95Z",
    className: "patternColor"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M248.99,544.2v-40.35l.82-.02v40.36c-.27,0-.55,0-.82.01Z",
    className: "patternColor"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M380.84,642v27.29c-2.68-1.37-3.45-22.2,0-27.29Z",
    className: "patternColor"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M325.7,617.21v-36.45h1.33v36.44c-.44,0-.89,0-1.33.01Z",
    className: "patternColor"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M518.99,580.99v36.24c-.43,0-.86-.01-1.29-.02v-36.46c.43.08.86.16,1.29.23h0Z",
    className: "patternColor"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M465.37,532.82v38.4c-2.67-5.45-2.08-34.88,0-38.4Z",
    className: "patternColor"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M172.45,571.2v-34.46l.88.03v34.48c-.29-.02-.59-.03-.88-.05Z",
    className: "patternColor"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M249.95,595.99c-1.65-2.32-2.3-32.25,0-38.16v38.16Z",
    className: "patternColor"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M263.89,525.96c3.76,3.55,3.31,24.06,0,26.39v-26.39Z",
    className: "patternColor"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M555.79,552.95v-26.01c3.52,1.76,3.98,21.97,0,26.01Z",
    className: "patternColor"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M225.87,463.29v-36.44h1.13v36.45h-1.13Z",
    className: "patternColor"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M266.14,488.17v25.26c-3.4-1.7-3.69-22.23,0-25.26Z",
    className: "patternColor"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M558.18,488.02v26.81c-1.45-1.78-2.38-2.4-2.51-3.16-1.19-7.25-.05-21.35,2.51-23.65Z",
    className: "patternColor"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M527.5,510.57c-.32,9.51.7,17.82-.83,27.2-2.94-4.96-2.66-23.77.83-27.2h0Z",
    className: "patternColor"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M232.92,536.44v-24.6c.4-.14.81-.27,1.21-.41.45,1.12,1.23,2.22,1.3,3.37.82,14.71.21,20.28-2.51,21.64h0Z",
    className: "patternColor"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M617.79,617.21v-36.35l1.08-.02v36.36h-1.08Z",
    className: "patternColor"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M486.98,546.31c3.68,4.54,3.18,22.76,0,24.95v-24.95Z",
    className: "patternColor"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M295.05,546.28c3.34,4.23,3.1,22.18,0,25.46v-25.46Z",
    className: "patternColor"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M417.88,617.2v-36.35h1.08v36.35h-1.08Z",
    className: "patternColor"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M556.22,463.7c-1.92-10.54-.84-23.09,1.99-24.46,1.12,13.46.54,22.21-1.99,24.46Z",
    className: "patternColor"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M596.06,567.85c-3.41-3.74-3.31-21.7,0-25.48v25.48Z",
    className: "patternColor"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M496.26,542.11v25.19c-3.5-2.51-3.86-21.2,0-25.19Z",
    className: "patternColor"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M304.22,567.82c-3.76-4.05-3.53-22.69,0-25.11v25.11Z",
    className: "patternColor"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M204.1,567.32c-3.48-2.55-3.62-21.04,0-24.85v24.85Z",
    className: "patternColor"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M194.96,544.99c3.55,5.44,3.25,23.09,0,26.58v-26.58Z",
    className: "patternColor"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M358.55,666.27c-3.47-2.94-3.89-19.57-1.04-24.98,1.84,8.7.57,16.36,1.04,24.98Z",
    className: "patternColor"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M311.92,648.35c-3.11-1.98-3.45-18.86,0-22.17v22.17Z",
    className: "patternColor"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M404.17,649.09c-3.74-3.49-3.32-20.01,0-22.37v22.37Z",
    className: "patternColor"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M479.12,572.52c3.18,3.26,3.26,19.36,0,22.31v-22.31Z",
    className: "patternColor"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M287.11,572.45c3.21,3.37,3.25,19.51,0,22.34v-22.34Z",
    className: "patternColor"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M603.73,471.62v22.76c-2.72-1.95-3.17-17.29,0-22.76Z",
    className: "patternColor"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M573.17,471.43c-3.69-2.84-3.63-19.17,0-21.71v21.71Z",
    className: "patternColor"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M486.88,622.38v-22.36c3.3,1.6,3.85,16.9,0,22.36Z",
    className: "patternColor"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M180.99,625.37c-3.24-2.68-3.45-18.35,0-22.08v22.08Z",
    className: "patternColor"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M281.3,603.19v22.01c-3.58-1.94-3.96-18.17,0-22.01Z",
    className: "patternColor"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M373.09,625.71c-3.48-3.45-3.41-19.1,0-22.22v22.22Z",
    className: "patternColor"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M473.27,603.38v21.91c-3.64-2.24-3.88-18.49,0-21.91Z",
    className: "patternColor"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M379.19,594.65v-22.37c3.2,3.79,3.05,19.88,0,22.37Z",
    className: "patternColor"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M212.41,494.69c-3.34-2.05-3.94-17.18-.73-21.74.93,7.07.79,14.19.73,21.74Z",
    className: "patternColor"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M187.42,572.88c2.93,4.04,2.61,19.29-.41,22.07-.64-7.8-.57-14.94.41-22.07Z",
    className: "patternColor"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M504.43,495.04c-3.35-2.61-3.81-17.72-.76-22.07.95,7.03.78,14.12.76,22.07Z",
    className: "patternColor"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M295.04,599.36c3.31,3.41,3.31,18.39,0,22.41v-22.41Z",
    className: "patternColor"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M281.57,518.39c-3.47-3.72-3.92-18.08-.98-23.81,1.66,8.38.5,15.52.98,23.81Z",
    className: "patternColor"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M510.26,590.34v-22.4c3.21,4.73,2.82,19.75,0,22.4Z",
    className: "patternColor"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M386.78,668.07v-22.29c3.54,2.27,3.89,17.39,0,22.29Z",
    className: "patternColor"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M318.21,590.57v-22.34c3.18,4.04,2.95,19.23,0,22.34Z",
    className: "patternColor"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M581.13,440.83c-3.66-2.87-3.42-19.44,0-21.22v21.22Z",
    className: "patternColor"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M632.93,564.92c3.64,3.61,3.29,19.56,0,21.56v-21.56Z",
    className: "patternColor"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M535.17,565.03v21.36c-3.36-1.52-3.74-18.02,0-21.36Z",
    className: "patternColor"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M432.93,587.19v-21.59c3.3,1.77,3.64,17.68,0,21.59Z",
    className: "patternColor"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M386.83,621.13v-21.4c3.88,2.6,3.74,18.52,0,21.4Z",
    className: "patternColor"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M396.13,599.23c-3.55-5.76-3.37-19.45,0-22.7v22.7Z",
    className: "patternColor"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M572.81,494.94v21.98c-2.8-1.5-3.52-16.85,0-21.98Z",
    className: "patternColor"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M610.08,590.61v-21.98c3.32,4.13,3.24,18.75,0,21.98Z",
    className: "patternColor"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M410.27,567.68c3.15,5.85,2.83,19.9,0,22.75v-22.75Z",
    className: "patternColor"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M304.18,576.69v21.34c-3.62-2.61-3.85-18.58,0-21.34Z",
    className: "patternColor"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M496.25,576.05v22.22c-3.49-3.04-3.84-18.22,0-22.22Z",
    className: "patternColor"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M587.14,468.11v-22.74c3.11,4.15,3.1,17.8,0,22.74Z",
    className: "patternColor"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M195.02,492.53c3.35,3.05,3.41,17.74,0,21.14v-21.14Z",
    className: "patternColor"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M295.08,492.74c3.19,2.57,3.44,17.23,0,21.1v-21.1Z",
    className: "patternColor"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M486.92,513.5v-20.71c3.55,2.37,3.69,17.67,0,20.71Z",
    className: "patternColor"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M586.9,513.34v-20.72c3.67,2.83,3.6,18.2,0,20.72Z",
    className: "patternColor"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M456.26,640.94c3.54,5.26,2.77,19.34,0,20.7v-20.7Z",
    className: "patternColor"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M240.89,585.06v-19.39c3.35,1.48,3.75,15.96,0,19.39Z",
    className: "patternColor"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M203.48,576.92v19.16c-.33-.03-.65-.06-.98-.09v-19.25c.33.06.65.12.98.18h0Z",
    className: "patternColor"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M373.17,668.42c-3.66-2.77-3.62-16.14,0-18.71v18.71Z",
    className: "patternColor"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M309.91,494.93v-18.3c3.37,1.63,3.67,15.21,0,18.3Z",
    className: "patternColor"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M425.31,632.96v-17.63h1.45v17.64h-1.45Z",
    className: "patternColor"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M334.73,614.98v18.16h-1.39v-18.14c.46,0,.93,0,1.39-.01h0Z",
    className: "patternColor"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M589.61,567.28c-4.29-7.46-2.98-14.28-2.01-21.07,2.78,6.48,1.42,13.3,2.01,21.07Z",
    className: "patternColor"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M625.33,634.36v-19.33c2.74,2.82,2.96,14.26,0,19.33Z",
    className: "patternColor"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M181.18,549.39v18.02c-3.53-2.65-3.65-14.38,0-18.02Z",
    className: "patternColor"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M373.11,594.8c-3.51-3.62-3.39-15.31,0-18.28v18.28Z",
    className: "patternColor"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M496.16,599.75v17.7c-3.65-2.89-3.57-15.25,0-17.7Z",
    className: "patternColor"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M234.88,488.36v18.32c-3.16-3.67-3.05-15.75,0-18.32Z",
    className: "patternColor"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M281.18,549.65v17.73c-3.65-2.63-3.66-15,0-17.73Z",
    className: "patternColor"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M473.16,549.61v17.72c-3.59-2.46-3.67-14.83,0-17.72Z",
    className: "patternColor"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M396.12,617.87c-3.54-3.75-3.38-15.45,0-18.31v18.31Z",
    className: "patternColor"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M573.24,522.89v18.16c-1.22-1.14-2.5-1.8-2.47-2.4.28-5.3-1.56-10.87,1.06-15.91.47.05.94.1,1.41.16h0Z",
    className: "patternColor"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M264.18,575.03v-17.2c2.79,1.15,3.47,12.64,0,17.2Z",
    className: "patternColor"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M181.29,576.2v18.01c-3.58-1.98-3.93-14.24,0-18.01Z",
    className: "patternColor"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M355.9,575.45v-17.76c3.6,2.39,3.66,14.89,0,17.76Z",
    className: "patternColor"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M524.48,487.69c3.54,3.12,3.87,14.38,1.27,19.15-2.15-6.38-.72-12.24-1.27-19.15Z",
    className: "patternColor"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M457.75,575.21c-3.23-5.63-2.53-16.07,0-17.42v17.42Z",
    className: "patternColor"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M304.29,599.17v18c-3.55-1.89-3.92-14.15,0-18Z",
    className: "patternColor"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M555.92,557.58c3.65,2.76,3.54,15.28,0,17.72v-17.72Z",
    className: "patternColor"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M473.29,522.29v17.97c-3.61-2.1-3.91-14.35,0-17.97Z",
    className: "patternColor"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M425.18,659.24v-17.86c3.47,4.04,3,16.61,0,17.86Z",
    className: "patternColor"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M281.24,576.89v17.43c-3.85-2.87-3.75-15.08,0-17.43Z",
    className: "patternColor"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M334.72,580.47c-3.26-5.74-2.66-17.36,0-18.61v18.61Z",
    className: "patternColor"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M524.47,560.7c3.55,3.1,3.88,14.37,1.27,19.13-2.15-6.38-.71-12.24-1.27-19.13Z",
    className: "patternColor"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M626.74,561.8v18.6c-3.26-5.45-2.74-17.17,0-18.6Z",
    className: "patternColor"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M281.13,540.88c-3.55-3.75-3.39-15.44,0-18.31v18.31Z",
    className: "patternColor"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M449.74,584.83v18.59c-3.27-5.54-2.72-17.23,0-18.59Z",
    className: "patternColor"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M257.9,601.99c-3.19-3.89-2.87-15.17,0-17.69v17.69Z",
    className: "patternColor"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M241.04,534.61c3.3,2.89,3.42,14.58,0,18.1v-18.1Z",
    className: "patternColor"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M526.97,478.96c-3.48-3.92-2.99-15.7,0-17.28v17.28Z",
    className: "patternColor"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M532.91,534.6c3.65,2.63,3.59,15.16,0,17.75v-17.75Z",
    className: "patternColor"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M234.75,461.57v18.83c-3.1-5.2-2.77-16.69,0-18.83Z",
    className: "patternColor"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M181.16,522.62v17.76c-3.6-2.36-3.65-14.89,0-17.76Z",
    className: "patternColor"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M473.19,575.75v18.26c-3.36-1.8-3.87-13.04,0-18.26Z",
    className: "patternColor"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M549.98,519.45c1.3,9.5.79,15.13-1.43,16.87-1.92-5.47-1.34-14.62,1.43-16.87Z",
    className: "patternColor"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M257.18,519.64c2.26,7.77,1.55,15.3-1.62,17.04.45-6-.99-11.68,1.62-17.04Z",
    className: "patternColor"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M509.97,486.51c-1.3-12.29-.8-15.88,2.27-17.18.9,12.72.66,14.85-2.27,17.18Z",
    className: "patternColor"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M334.96,659.68c-2.86-2.98-3.3-13.32-1.14-17.62,1.93,2.37,2.39,8.83,1.14,17.62Z",
    className: "patternColor"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M570.61,440.17c.49-5.48-1.19-11.18,1.9-16.41.88,5.61,1.41,11.19.55,16.66-.82-.09-1.64-.17-2.45-.26h0Z",
    className: "patternColor"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M173.38,592.58v20.73c-.43,0-.87,0-1.3.01v-20.62c.43-.04.87-.08,1.3-.11h0Z",
    className: "patternColor"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M365.4,592.57v20.71c-.43,0-.85.02-1.28.03v-20.56c.43-.06.85-.11,1.28-.17h0Z",
    className: "patternColor"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M564.04,459.73v-20.79c.42-.02.84-.04,1.26-.06,1.35,6.9.16,13.91.36,20.86-.54,0-1.08,0-1.62-.01Z",
    className: "patternColor"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M548.37,600.62c-1.31-12.99-1.13-14.42,2.1-16.27-.64,5.78,1.54,11.37-2.1,16.27Z",
    className: "patternColor"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M220.32,419.91c.42,9.72-.63,15.39-3.16,17.01.59-6.23,1.11-11.71,1.63-17.19.51.06,1.02.12,1.53.18Z",
    className: "patternColor"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M225.63,517.28v-21c.38-.02.76-.04,1.13-.06v20.87c-.38.07-.76.13-1.13.2h0Z",
    className: "patternColor"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M517.87,517.23v-20.95l1.05-.03v20.96l-1.05.02h0Z",
    className: "patternColor"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M194.76,599.18c3.83,3.75,3.59,10.81,0,17.17v-17.17Z",
    className: "patternColor"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M495.51,630.88c1.66,10.11,1.35,12.91-1.72,16.09.07-5.96-1.28-11.26,1.72-16.09Z",
    className: "patternColor"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M464.19,612.83v-20.51c2.37,5.81,1.7,19.73,0,20.51Z",
    className: "patternColor"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M273.26,592.4v20.86l-1.08-.09v-20.83c.36.02.72.04,1.08.05h0Z",
    className: "patternColor"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M504.61,626.51c-.7,5.42.99,10.38-1.86,16.16-2.18-8.24-1.48-14.76,1.86-16.16Z",
    className: "patternColor"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M581.12,457.28v14.19c-3.42-1.85-3.6-11.46,0-14.19Z",
    className: "patternColor"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M289.12,538.28v14.19c-3.42-1.85-3.6-11.47,0-14.19Z",
    className: "patternColor"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M480.95,552.31c-3.17-1.5-3.48-11.06,0-14.04v14.04Z",
    className: "patternColor"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M509.83,552.79v-14.09c3.54,1.65,3.76,10.42,0,14.09Z",
    className: "patternColor"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M419.06,649.86v19.38c-.36,0-.72.01-1.07.02v-19.4h1.07Z",
    className: "patternColor"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M186.92,538.62c3.67,1.83,3.57,11.29,0,13.68v-13.68Z",
    className: "patternColor"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M626.81,595.96v14.21c-2.72-2.75-3.02-9.91,0-14.21Z",
    className: "patternColor"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M317.84,552.79v-14.09c3.54,1.64,3.76,10.41,0,14.09Z",
    className: "patternColor"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M526.84,595.98v14.69c-2.76-3.32-3-10.52,0-14.69Z",
    className: "patternColor"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M426.85,596.07v13.67c-.48,0-.96.02-1.45.02-1.45-4.54-1.02-9.13-.21-13.73l1.65.03h.01Z",
    className: "patternColor"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M334.83,596.06v14.01c-.43,0-.86,0-1.3.01-1.67-4.66-1.14-9.36-.32-14.08l1.62.06Z",
    className: "patternColor"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M235.03,442.57c.2,4.49.4,8.98.59,13.48l-1.95.26c-2.32-4.18-.56-8.97-1.06-13.43.8-.1,1.61-.2,2.41-.31h0Z",
    className: "patternColor"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M480.71,626.54c-3.17-5.63-2.67-13.37,0-14.7v14.7Z",
    className: "patternColor"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M609.77,517.88v-14.02c3.56,1.92,3.88,10.27,0,14.02Z",
    className: "patternColor"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M188.75,626.4c-3.2-5.29-2.76-13.13,0-14.61v14.61Z",
    className: "patternColor"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M379.3,611.78c2.78,1.49,3.21,9.35,0,14.59v-14.59Z",
    className: "patternColor"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M518.96,538.9v17.28c-.42,0-.83-.02-1.25-.03v-17.4c.42.05.83.1,1.25.15Z",
    className: "patternColor"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M294.88,486.64v-13.98c3.52,2.99,3.62,10.71,0,13.98Z",
    className: "patternColor"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M509.82,518.02v-14c3.43,1.55,3.84,9.9,0,14Z",
    className: "patternColor"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M632.78,636.75v-13.95c3.6,2.11,3.84,10.45,0,13.95Z",
    className: "patternColor"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M317.98,503.37c3.4,3.32,3.36,11.12,0,14.22v-14.22Z",
    className: "patternColor"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M217.78,517.75v-13.96c3.6,2.13,3.85,10.47,0,13.96Z",
    className: "patternColor"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M326.95,538.91v17.28c-.41,0-.82-.02-1.24-.03v-17.41c.41.05.82.1,1.24.16Z",
    className: "patternColor"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M610.01,538.5c3.32,3.03,3.36,10.86,0,14.16v-14.16Z",
    className: "patternColor"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M570.42,563.95c1.06-4.65-1.49-9.86,1.69-14.19.56.07,1.12.15,1.68.22-.45,4.77-.91,9.53-1.36,14.3-.67-.11-1.34-.22-2.01-.33h0Z",
    className: "patternColor"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M287.25,611.36c2.66,2.35,3.05,8.53,1.24,13.46-2.21-1.68-2.66-6.16-1.24-13.46Z",
    className: "patternColor"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M304.24,629.84v14.7c-3.44-2.13-3.84-9.5,0-14.7Z",
    className: "patternColor"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M586.83,487.09v-14.18c3.41,2.31,3.79,9.89,0,14.18Z",
    className: "patternColor"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M386.86,640.6v-13.96c3.56,3.29,3.64,10.63,0,13.96Z",
    className: "patternColor"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M487.02,626.22c3.33,4.66,3.32,11.15,0,14.45v-14.45Z",
    className: "patternColor"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M595.11,463.32c-3.14-4.23-.66-9.32-1.65-13.89l1.81-.24c.52,4.63,1.04,9.26,1.56,13.89-.57.08-1.14.16-1.72.24Z",
    className: "patternColor"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M340.77,552.91v-13.64c3.52,2.64,3.84,9.81,0,13.64Z",
    className: "patternColor"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M203.87,533.94c-3.29-5.26-2.97-11.85,0-14.05v14.05Z",
    className: "patternColor"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M303.87,533.92c-3.3-5.17-2.97-11.9,0-14.05v14.05Z",
    className: "patternColor"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M495.85,519.93v14.13c-3.3-5.45-2.93-12.11,0-14.13Z",
    className: "patternColor"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M595.79,534.36c-3.06-5.7-2.84-11.89,0-14.74v14.74Z",
    className: "patternColor"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M618.97,538.76v17.39h-1.16v-17.39h1.16Z",
    className: "patternColor"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M410.06,657.66c3.24,2.74,3.38,9.54,0,13.09v-13.09Z",
    className: "patternColor"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M296.79,639.28c-2.55-1.33-3-4.64-1.67-12.38,2.73,2.72,3.16,5.95,1.67,12.38Z",
    className: "patternColor"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M225.96,555.65v-16.87c.34-.01.69-.02,1.03-.04v16.86c-.34.01-.69.03-1.03.04h0Z",
    className: "patternColor"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M426.78,566.77v13.43c-3.12-4.74-2.8-10.89,0-13.43Z",
    className: "patternColor"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M480.9,642.08c.37,3.96,2.1,8.05-1.71,12.23v-12.3l1.71.07Z",
    className: "patternColor"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M565.43,480.77v13.55c-.44.01-.88.02-1.31.04v-13.42l1.31-.17h0Z",
    className: "patternColor"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M197.15,474.88c.05,3.86,1.44,7.85-1.01,11.45-.58-.06-1.16-.12-1.73-.18.42-3.81.83-7.62,1.25-11.42.5.05,1,.1,1.49.16h0Z",
    className: "patternColor"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M458.79,540.28c-.37,4.79-.66,8.46-.95,12.13-.78-.1-1.55-.2-2.33-.3.89-3.59-1.78-7.73,3.28-11.83Z",
    className: "patternColor"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M234.05,573.43c-.63-3.83-1.26-7.65-1.89-11.48l1.97-.35c2.94,3.4.47,7.8,1.5,11.56-.52.09-1.05.18-1.57.27h0Z",
    className: "patternColor"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M363.89,648.16v-13.3c2.93,4.38,1.81,8.9,1.49,13.38-.5-.03-.99-.05-1.49-.08Z",
    className: "patternColor"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M248.98,459.22v-14.72c1.78,1.94,2.21,8.23,0,14.72Z",
    className: "patternColor"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M271.9,494.21v-13.33c.4-.01.8-.03,1.2-.04v13.43c-.4-.02-.8-.04-1.2-.06Z",
    className: "patternColor"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M563.92,521.18v-13.33c.4-.01.8-.03,1.2-.04v13.4c-.4-.01-.8-.02-1.2-.04h0Z",
    className: "patternColor"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M165.48,561.73c.28,4.61,2.43,9.45-.3,13.68-.54-.07-1.08-.14-1.62-.21l1.92-13.47Z",
    className: "patternColor"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M464.01,648.1v-13.27h1.35v13.42c-.45-.05-.9-.11-1.35-.16h0Z",
    className: "patternColor"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M242.66,446.08c1.25,3.45,1.4,6.84-1.36,10.11v-10.17c.45.02.91.04,1.36.06h0Z",
    className: "patternColor"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M334.88,546.06v9.71c-.59.04-1.17.07-1.76.11-.77-3.23-1.05-6.49.22-9.86.51.02,1.03.03,1.54.05h0Z",
    className: "patternColor"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M626.71,545.93v10.13c-.45,0-.91-.01-1.36-.02v-10.13c.45,0,.91.01,1.36.02Z",
    className: "patternColor"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M533.11,599.8c3.14,2.37,3.37,7.1,0,10v-10Z",
    className: "patternColor"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M432.96,609.53v-9.85c3.45,2.66,3.52,7.65,0,9.85Z",
    className: "patternColor"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M632.96,609.51v-9.64c3.46,2.06,3.66,7.46,0,9.64Z",
    className: "patternColor"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M627.12,590.72c-3.48-2.6-3.39-7.29,0-10.2v10.2Z",
    className: "patternColor"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M525.23,556.01v-10.01l1.45-.02v10.06c-.48-.01-.96-.02-1.45-.03h0Z",
    className: "patternColor"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M234.7,545.93v10.11c-.45,0-.9.02-1.35.02v-10.11l1.35-.02Z",
    className: "patternColor"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M272.03,521.22v-13.38h1.06v13.38h-1.06Z",
    className: "patternColor"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1,580.3v10.21c-3.36-2.01-3.43-6.81,0-10.21Z",
    className: "patternColor"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M595.96,588.87c-1.17-4.43-4.34-8.08,0-13.13v13.13Z",
    className: "patternColor"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M541,498.2v-13.35h.95v13.35h-.95Z",
    className: "patternColor"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M486.8,541v-10.21c3.5,2.52,3.71,6.34,0,10.21Z",
    className: "patternColor"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M441.99,638.85v13.36c-.32,0-.63,0-.95.01v-13.35c.32,0,.63-.01.95-.02Z",
    className: "patternColor"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M294.93,540.41v-9.9c3.5,3.54,3.47,7.21,0,9.9Z",
    className: "patternColor"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M335.26,580.07v10.09c-3.53-1.56-3.81-6.15,0-10.09Z",
    className: "patternColor"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M527.14,590.5c-3.61-2.67-3.54-7.3,0-9.78v9.78Z",
    className: "patternColor"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M250.06,484.86v13.37h-.95v-13.37h.95Z",
    className: "patternColor"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M586.84,540.08v-9.34c3.71,2.61,3.57,7.67,0,9.34Z",
    className: "patternColor"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M195.07,530.16c3.17,3.76,3.08,7.63,0,10.28v-10.28Z",
    className: "patternColor"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M363.96,571.22v-10.84c2.64,3.54,1.8,7.18,0,10.84Z",
    className: "patternColor"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M555.74,589.97v-9c3.79,1.79,3.86,5.69,0,9Z",
    className: "patternColor"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M525.21,623.66v-9.34c3.37,4.13,2.93,8.01,0,9.34Z",
    className: "patternColor"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M486.89,486.4v-8.76c3.59,1.64,3.57,6.16,0,8.76Z",
    className: "patternColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternL);
export default __webpack_public_path__ + "static/media/patternL.3233d6ff1a3b8f9ffbabc9d3dda37514.svg";
export { ForwardRef as ReactComponent };